/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Audio_Recorder_Event_LabelInputs */

const en_audio_recorder_event_label = /** @type {(inputs: Audio_Recorder_Event_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index}`)
};

const fr_audio_recorder_event_label = /** @type {(inputs: Audio_Recorder_Event_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Événement ${i?.index}`)
};

const de_audio_recorder_event_label = /** @type {(inputs: Audio_Recorder_Event_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ereignis ${i?.index}`)
};

const it_audio_recorder_event_label = /** @type {(inputs: Audio_Recorder_Event_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento ${i?.index}`)
};

const ru_audio_recorder_event_label = /** @type {(inputs: Audio_Recorder_Event_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index}`)
};

const es_audio_recorder_event_label = /** @type {(inputs: Audio_Recorder_Event_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento ${i?.index}`)
};

const zh_cn2_audio_recorder_event_label = /** @type {(inputs: Audio_Recorder_Event_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件${i?.index}`)
};

const ja_audio_recorder_event_label = /** @type {(inputs: Audio_Recorder_Event_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index}`)
};

const hi_audio_recorder_event_label = /** @type {(inputs: Audio_Recorder_Event_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`घटना ${i?.index}`)
};

const pt_pt2_audio_recorder_event_label = /** @type {(inputs: Audio_Recorder_Event_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Event {index}" |
*
* @param {Audio_Recorder_Event_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_event_label = /** @type {((inputs: Audio_Recorder_Event_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Event_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_event_label(inputs)
	if (locale === "de") return de_audio_recorder_event_label(inputs)
	if (locale === "it") return it_audio_recorder_event_label(inputs)
	if (locale === "ru") return ru_audio_recorder_event_label(inputs)
	if (locale === "es") return es_audio_recorder_event_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_event_label(inputs)
	if (locale === "ja") return ja_audio_recorder_event_label(inputs)
	if (locale === "hi") return hi_audio_recorder_event_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_event_label(inputs)
	return en_audio_recorder_event_label(inputs)
});